import { BillingContainer } from './BillingContainer';
import { SideBarAccount } from '../../navigation/SideBar';
import { LogoGrowegy } from '../../assets/icons';
import React from 'react';
import useAuth from '../../auth/authContext';
import { PleaseRelogin } from '../../auth/PleaseRelogin';
import { Permission } from '../../auth/permissions';
import { ReactivationBanner } from '../components/ReactivationBanner';
import {
  Customer,
  OFFER_REACTIVATE_FOR_ANNUAL_DISCOUNT,
  OFFER_REACTIVATE_FOR_BENEFITS,
} from '../types';
import { getBillingPlan } from '../billingPlans';

export const CancelledSubscriptionBilling = (props: { customer: Customer }) => {
  const { customer } = props;
  const {
    state: { user },
  } = useAuth();
  if (!user) return <PleaseRelogin />;

  const billingPlan = getBillingPlan(customer.planName);
  const reactivationOffer =
    customer.availableOffers?.indexOf(OFFER_REACTIVATE_FOR_BENEFITS) >= 0
      ? OFFER_REACTIVATE_FOR_BENEFITS
      : customer.availableOffers?.indexOf(OFFER_REACTIVATE_FOR_ANNUAL_DISCOUNT) >= 0
      ? OFFER_REACTIVATE_FOR_ANNUAL_DISCOUNT
      : null;

  return (
    <div className="app-main">
      <div className="billing__cancelled-container">
        <div className="billing__cancelled-header">
          <img src={LogoGrowegy} alt="" />
          <span className="growegy-font20--weight500 flex-grow-1 ">Growegy — Billing</span>
          <SideBarAccount signOutOnly={true} />
        </div>
        <div className="billing__cancelled-body">
          {user.has(Permission.CHANGE_BILLING) ? (
            <>
              {billingPlan && reactivationOffer && (
                <ReactivationBanner billingPlan={billingPlan} offer={reactivationOffer} />
              )}
              <BillingContainer source="cancelled-subscription" />
            </>
          ) : (
            <div className="billing__account-management-disabled-banner">
              Your plan has been canceled.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
